var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCounter = function SvgCounter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.55,
    cy: 10,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.186 15v-1.114l3.446-3.57q.551-.581.91-1.018.363-.442.542-.84.178-.398.178-.846 0-.507-.238-.875a1.56 1.56 0 0 0-.651-.572 2.1 2.1 0 0 0-.93-.203q-.547 0-.955.223-.407.225-.626.632a2 2 0 0 0-.219.954H7.176q0-.93.428-1.625a2.9 2.9 0 0 1 1.173-1.08q.747-.387 1.696-.387.96 0 1.69.383.735.377 1.148 1.034.413.652.413 1.471 0 .567-.214 1.11-.209.54-.73 1.207-.522.661-1.452 1.606l-2.024 2.118v.074h4.584V15z"
  })));
};
export default SvgCounter;